import { Link } from 'react-router-dom';

export default function SupplementDrugInteractions() {
  const supplementInteractions = [
    {
      supplement: 'セントジョーンズワート',
      effects: '多くの薬の効果を減弱',
      affectedDrugs: ['抗うつ薬', 'ワルファリン', '経口避妊薬', '免疫抑制薬'],
      mechanism: 'CYP3A4酵素の誘導により薬物代謝が促進',
      precautions: '服用中の薬がある場合は必ず医師・薬剤師に相談'
    },
    {
      supplement: 'イチョウ葉エキス',
      effects: '出血リスクの増加',
      affectedDrugs: ['ワルファリン', 'アスピリン', 'クロピドグレル'],
      mechanism: '血小板凝集抑制作用の相加効果',
      precautions: '手術前は2週間前から中止を検討'
    },
    {
      supplement: 'ビタミンK',
      effects: 'ワルファリンの効果を減弱',
      affectedDrugs: ['ワルファリン'],
      mechanism: 'ビタミンKがワルファリンの作用に拮抗',
      precautions: '青汁や納豆などビタミンK含有食品も注意'
    },
    {
      supplement: 'カルシウム',
      effects: '薬の吸収を阻害',
      affectedDrugs: ['テトラサイクリン系抗生物質', 'ビスホスホネート製剤'],
      mechanism: 'キレート形成により吸収が阻害',
      precautions: '服用時間を2時間以上空ける'
    },
    {
      supplement: 'マグネシウム',
      effects: '薬の吸収を阻害',
      affectedDrugs: ['キノロン系抗生物質', 'テトラサイクリン系抗生物質'],
      mechanism: 'キレート形成により吸収が阻害',
      precautions: '制酸薬との併用も注意が必要'
    },
    {
      supplement: '鉄分',
      effects: '薬の吸収を阻害',
      affectedDrugs: ['レボドパ', 'キノロン系抗生物質'],
      mechanism: 'キレート形成や競合的阻害',
      precautions: '服用時間をずらすか医師に相談'
    },
    {
      supplement: 'オメガ3脂肪酸（EPA/DHA）',
      effects: '出血リスクの増加',
      affectedDrugs: ['抗凝固薬', '抗血小板薬'],
      mechanism: '血小板凝集抑制作用の増強',
      precautions: '高用量摂取時は特に注意'
    },
    {
      supplement: 'ガーリック（ニンニク）',
      effects: '出血リスクの増加、血糖降下',
      affectedDrugs: ['抗凝固薬', '糖尿病薬'],
      mechanism: '血小板凝集抑制、インスリン感受性向上',
      precautions: '手術前は中止を検討'
    },
    {
      supplement: 'ジンセン（高麗人参）',
      effects: '血糖値や血圧への影響',
      affectedDrugs: ['糖尿病薬', '降圧薬', 'ワルファリン'],
      mechanism: '血糖降下作用、血圧への影響',
      precautions: '定期的な血糖・血圧測定が重要'
    },
    {
      supplement: 'コエンザイムQ10',
      effects: 'ワルファリンの効果を減弱',
      affectedDrugs: ['ワルファリン'],
      mechanism: 'ビタミンK様作用による拮抗',
      precautions: 'INR値の定期的な監視が必要'
    }
  ];

  const safetyTips = [
    {
      title: '医師・薬剤師への相談',
      description: 'サプリメント開始前に必ず相談し、服用中の薬との相互作用を確認する',
      icon: 'ri-user-heart-line'
    },
    {
      title: '服用記録の管理',
      description: 'お薬手帳にサプリメントも記載し、医療機関で情報を共有する',
      icon: 'ri-book-line'
    },
    {
      title: '用法・用量の遵守',
      description: '推奨量を守り、複数のサプリメントの重複摂取に注意する',
      icon: 'ri-medicine-bottle-line'
    },
    {
      title: '定期的な検査',
      description: '血液検査などで薬の効果や副作用をモニタリングする',
      icon: 'ri-test-tube-line'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
              <Link to="/information" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
            </nav>
            <button className="md:hidden p-2">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Breadcrumb */}
      <nav className="bg-gray-50 py-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-2 text-sm">
            <Link to="/" className="text-gray-500 hover:text-teal-600 cursor-pointer">ホーム</Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <Link to="/beast-blog" className="text-gray-500 hover:text-teal-600 cursor-pointer">ビースト君ブログ</Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-900">サプリメントと薬の飲み合わせ</span>
          </div>
        </div>
      </nav>

      {/* Article Header */}
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <header className="mb-12">
          <div className="flex items-center mb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-full flex items-center justify-center mr-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/dbe372861181c69374dfc05760b8ebc3.jpg"
                alt="ビースト君"
                className="w-14 h-14 object-cover object-top rounded-full border-2 border-teal-300"
              />
            </div>
            <div>
              <div className="flex items-center gap-3 mb-2">
                <span className="bg-teal-100 text-teal-800 text-sm px-3 py-1 rounded-full font-medium">薬学知識</span>
                <span className="bg-red-100 text-red-800 text-sm px-3 py-1 rounded-full font-medium">NEW</span>
                <span className="text-gray-500 text-sm">2025年10月8日</span>
              </div>
              <p className="text-gray-600">ビースト君 • 薬剤師</p>
            </div>
          </div>
          
          <h1 className="text-4xl font-bold text-gray-900 mb-6">
            サプリメントと薬の飲み合わせは大丈夫？注意すべき組み合わせ一覧
          </h1>
          
          <div className="relative mb-8">
            <img 
              src="https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20in%20modern%20pharmacy%20explaining%20supplement-drug%20interactions%20with%20various%20supplement%20bottles%20and%20prescription%20medicines%20displayed%20on%20consultation%20table%2C%20educational%20illustration%20showing%20warning%20signs%20about%20drug%20interactions%2C%20professional%20healthcare%20setting%20with%20charts%20showing%20supplement%20safety%20information%2C%20friendly%20cartoon%20style%20with%20detailed%20pharmacy%20background&width=800&height=400&seq=beast-supplement-drug-interactions-hero&orientation=landscape"
              alt="サプリメントと薬の飲み合わせについて説明するビースト君"
              className="w-full h-96 object-cover object-top rounded-xl shadow-lg"
            />
          </div>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-xl text-gray-600 leading-relaxed">
              こんにちは、ビースト君です！💪 今日は多くの方が気になっている「サプリメントと薬の飲み合わせ」について詳しく解説します。
              健康のために摂取しているサプリメントが、実は薬の効果に影響を与えることがあるんです。
              筋トレでサプリメントを愛用している私だからこそ、この問題の重要性を実感しています。
            </p>
          </div>
        </header>

        {/* Introduction */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">なぜサプリメントと薬の相互作用が起こるのか？</h2>
          
          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-8 mb-8">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-information-line text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">相互作用のメカニズム</h3>
                <div className="space-y-3 text-gray-700">
                  <p><strong>吸収の阻害：</strong>サプリメントの成分が薬の吸収を妨げる</p>
                  <p><strong>代謝の変化：</strong>肝臓の酵素活性が変化し、薬の代謝速度が変わる</p>
                  <p><strong>作用の重複：</strong>サプリメントと薬が同じような作用を持つ</p>
                  <p><strong>排泄の影響：</strong>腎臓からの薬の排泄が変化する</p>
                </div>
              </div>
            </div>
          </div>

          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            サプリメントは「食品」として分類されていますが、体内では薬と同様に様々な生理作用を示します。
            特に、肝臓での薬物代謝酵素（CYP酵素）への影響や、消化管での吸収競合などが主な相互作用のメカニズムです。
          </p>
        </section>

        {/* Supplement Interactions List */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">注意すべきサプリメントと薬の組み合わせ</h2>
          
          <div className="grid gap-6">
            {supplementInteractions.map((item, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
                <div className="flex items-start justify-between mb-4">
                  <h3 className="text-xl font-bold text-teal-600">{item.supplement}</h3>
                  <div className="bg-red-100 text-red-800 text-sm px-3 py-1 rounded-full font-medium">
                    注意
                  </div>
                </div>
                
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">影響する薬</h4>
                    <div className="flex flex-wrap gap-2 mb-4">
                      {item.affectedDrugs.map((drug, idx) => (
                        <span key={idx} className="bg-gray-100 text-gray-700 text-sm px-3 py-1 rounded-full">
                          {drug}
                        </span>
                      ))}
                    </div>
                    
                    <h4 className="font-semibold text-gray-900 mb-2">起こりうる影響</h4>
                    <p className="text-gray-700 mb-4">{item.effects}</p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">作用メカニズム</h4>
                    <p className="text-gray-700 mb-4">{item.mechanism}</p>
                    
                    <h4 className="font-semibold text-gray-900 mb-2">注意点</h4>
                    <p className="text-gray-700">{item.precautions}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Safety Tips */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">安全にサプリメントを使用するためのポイント</h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            {safetyTips.map((tip, index) => (
              <div key={index} className="bg-gradient-to-br from-green-50 to-teal-50 rounded-xl p-6 border border-green-100">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-green-100 text-green-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className={`${tip.icon} text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{tip.title}</h3>
                    <p className="text-gray-700">{tip.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Beast-kun's Experience */}
        <section className="mb-12">
          <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-xl p-8">
            <div className="flex items-start">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                <img 
                  src="https://readdy.ai/api/search-image?query=Friendly%20muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20and%20white%20coat%2C%20cartoon%20mascot%20style%2C%20cheerful%20expression%2C%20strong%20build%2C%20professional%20healthcare%20worker%2C%20anime%20character%20design%20with%20defined%20muscles%2C%20welcoming%20pose%2C%20clean%20simple%20background&width=60&height=60&seq=beast-kun-experience-supplement&orientation=squarish"
                  alt="ビースト君"
                  className="w-14 h-14 object-cover object-top rounded-full border-2 border-teal-300"
                />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-teal-600 mb-4">ビースト君の実体験</h3>
                <div className="space-y-4 text-gray-700">
                  <p>
                    筋トレを始めた頃、プロテインやクレアチン、各種ビタミンなど多くのサプリメントを摂取していました。
                    ある時、風邪で抗生物質を処方された際、薬剤師として自分のサプリメント摂取状況を見直したんです。
                  </p>
                  <p>
                    特に、マルチビタミンに含まれるカルシウムや鉄分が抗生物質の吸収を阻害する可能性があることに気づき、
                    服用時間を調整しました。この経験から、サプリメントも薬と同様に慎重に扱う必要があると実感しています。
                  </p>
                  <p>
                    現在は、新しいサプリメントを始める前に必ず文献を調べ、患者さんにも同様のアドバイスをしています。
                    健康のためのサプリメントが逆効果にならないよう、正しい知識を持つことが大切ですね！💪
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Conclusion */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">まとめ</h2>
          
          <div className="bg-white border-2 border-teal-200 rounded-xl p-8">
            <div className="space-y-4 text-gray-700">
              <p>
                サプリメントと薬の相互作用は、思っている以上に複雑で重要な問題です。
                特に複数の薬を服用している方や、慢性疾患をお持ちの方は注意が必要です。
              </p>
              <p>
                サプリメントを始める前、または新しい薬が処方された際は、必ず医師や薬剤師に相談してください。
                お薬手帳にサプリメントの情報も記載し、医療機関で情報を共有することが安全な治療につながります。
              </p>
              <p>
                健康維持のためのサプリメントが、治療の妨げにならないよう、正しい知識を持って賢く活用しましょう！
              </p>
            </div>
          </div>
        </section>

        {/* Related Articles */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">関連記事</h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <Link to="/beast-blog/drug-food-interactions" className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow cursor-pointer">
              <div className="flex items-center mb-3">
                <div className="w-8 h-8 bg-teal-100 text-teal-600 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-restaurant-line"></i>
                </div>
                <span className="text-sm text-gray-500">2025.10.07</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">薬の飲み合わせで注意すべき食べ物10選</h3>
              <p className="text-gray-600">薬と食べ物の相互作用について詳しく解説します。</p>
            </Link>
            
            <Link to="/beast-blog/medicine-not-working" className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow cursor-pointer">
              <div className="flex items-center mb-3">
                <div className="w-8 h-8 bg-teal-100 text-teal-600 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-medicine-bottle-line"></i>
                </div>
                <span className="text-sm text-gray-500">2025.10.06</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">薬が効かないときの原因5選</h3>
              <p className="text-gray-600">薬の効果が感じられない時の原因と対処法を解説します。</p>
            </Link>
          </div>
        </section>

        {/* Back to Blog */}
        <div className="text-center">
          <Link 
            to="/beast-blog" 
            className="inline-flex items-center bg-teal-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            ビースト君ブログ一覧に戻る
          </Link>
        </div>
      </article>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">患者さん向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-support" className="hover:text-white cursor-pointer">健康サポート</Link></li>
                <li><Link to="/otc" className="hover:text-white cursor-pointer">OTC医薬品</Link></li>
                <li><Link to="/kampo" className="hover:text-white cursor-pointer">漢方相談</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">薬剤師向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/sterile-preparation" className="hover:text-white cursor-pointer">無菌調剤</Link></li>
                <li><Link to="/home-care" className="hover:text-white cursor-pointer">在宅医療</Link></li>
                <li><Link to="/dx" className="hover:text-white cursor-pointer">薬局DX</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/information" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職・派遣情報</Link></li>
                <li><Link to="/entertainment" className="hover:text-white cursor-pointer">エンタメ</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}